import moment from 'moment';
import { showToaster, toasterTypes } from '../widgets';

export const expectedDateFormat = (value, toFormat, fromFormat = '') => {
    if (fromFormat) {
        return moment(value, fromFormat).format(toFormat)
    } else {
        return moment(value).format(toFormat)
    }
}

export const copyData = (value, hideToast) => {
    console.log('value, hideToast', value, hideToast)
    var textField = document.createElement('textarea');
    textField.innerText = value;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand('copy');
    textField.remove();
    if (!hideToast) {
        showToaster(toasterTypes.SUCCESS, 'Copied Successfully');
    }
}

export const setCookie = (name: string, value: string, days: number = 365) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Lax;`;
}

export const getCookie = (name: string) => {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}